import useIsNLplan from '../../common/src/hooks/useIsNLPlan';
import {
  flowIdCompanyScanBE,
  flowIdCompanyScanNL,
} from '../../flows/src/constants/flowIds';

const useCompanyScanFlowId = (): string => {
  const { isNL } = useIsNLplan();

  if (isNL) return flowIdCompanyScanNL;

  return flowIdCompanyScanBE;
};

export default useCompanyScanFlowId;
